import React from 'react'
import Iframe from 'react-iframe';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'

import Breadcrumb from 'molecules/Breadcrumb';
import { RoundedWrapper, IframeWrapper, PageWrapper } from './styles'
const { REPORT_URL } = process.env

const Item = ({
  match: { params: { id } },
  viewState: { isMobileView }
}) => {
  const reportUri = `${REPORT_URL}BARGE_CHECKLIST&ISSUE_ID=${id}`

  function getIframeHeight() {
    const w = window.innerWidth
    const h = window.innerHeight
    return w <= 768 ? `${h - 384}px` : `${h - 300}px`
  }

  return (
    <PageWrapper isMobile={isMobileView}>
      <Breadcrumb
        navList={[
          'Report',
          'Report Barge Checklist',
          'Detail Report',
        ]}
      />
      <RoundedWrapper>
        <div className={'mt-3'}>
          <IframeWrapper>
            <Iframe
              url={reportUri}
              width="100%"
              height={getIframeHeight()}
              display="initial"
              position="relative"
              frameBorder="0"
            />
          </IframeWrapper>
        </div>
      </RoundedWrapper>
    </PageWrapper>
  )
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState
  }
}

export default withRouter(
  connect(mapStateToProps)(Item)
)
